import authAxios from '@services/authAxios';

const fetchAuditTrailSummary = async () => {
    const { data } = await authAxios({
        method: 'GET',
        url: `/api/v1/audit-trail/summary`,
    });

    return data?.data;
};

export default fetchAuditTrailSummary;
